import { useState } from "react";
import Icon from "../components/Icon";
import DonutChart from "../components/widgets/DonutChart";
import FichajeWidget from "../components/widgets/FichajeWidget";
import CronometroWidget from "../components/widgets/CronometroWidget";
import { AG_TIPO_CLR } from "../constants";
import { prodStats, prodBand, fmtRatio, fmtHours } from "../utils";
import MisProyectos from "../components/widgets/MisProyectos";
import MisTareasCard from "../components/widgets/MisTareasCard";

export default function HomeDashboard({notionItems=[],agenda=[],agendaTiposData=[],go,setModal,currentUser,onHomePdf,fichaje,
  crono,misPasos=[],verIncidencias=false,onAbrirPanel,onCerrarJornada,senalElegir=0,onAbrirProyecto=()=>{},verMisTareas=false}) {
  const [dashMes,setDashMes]=useState("");
  const wRange=()=>{
    const d=new Date(); const day=d.getDay(); const diff=day===0?-6:1-day;
    const lun=new Date(d); lun.setDate(d.getDate()+diff);
    const dom=new Date(lun); dom.setDate(lun.getDate()+6);
    return[lun.toISOString().slice(0,10),dom.toISOString().slice(0,10)];
  };
  const [wLun,wDom]=wRange();
  const currentYear=String(new Date().getFullYear());
  const allMonths=[...new Set(agenda.map(a=>a.entry_date?.slice(0,7)).filter(Boolean))].sort().reverse();
  const myAgenda=agenda.filter(a=>{
    const mine=String(a.user_id)===String(currentUser?.id);
    if(!mine)return false;
    if(dashMes==="__total__")return true;
    if(dashMes==="__year__")return a.entry_date?.startsWith(currentYear);
    if(dashMes)return a.entry_date?.startsWith(dashMes);
    return a.entry_date>=wLun&&a.entry_date<=wDom;
  });
  const agH=myAgenda.reduce((s,a)=>s+(a.hours||0),0);
  const agByTipo={};
  myAgenda.forEach(a=>{const tp=a.type||"Otros";agByTipo[tp]=(agByTipo[tp]||0)+(a.hours||0);});
  // Índice de productividad del período: horas ponderadas por el peso de su tipo
  const prod=prodStats(myAgenda,agendaTiposData);
  const prodB=prod.index===null?null:prodBand(prod.index);
  const notionDbs=notionItems.filter(i=>i.item_type==="database");
  const notionPages=notionItems.filter(i=>i.item_type==="page");
  const label=dashMes==="__total__"
    ?"Total acumulado"
    :dashMes==="__year__"
      ?`Año ${currentYear}`
      :dashMes
        ?new Date(dashMes+"-02").toLocaleString("es-ES",{month:"long",year:"numeric"}).replace(/^\w/,c=>c.toUpperCase())
        :"Semana actual";
  const card={background:"var(--surface)",borderRadius:13,border:"1px solid var(--border)",boxShadow:"var(--shadow-sm)"};
  return (
    <div className="fu">
      {/* Saludo */}
      <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:18,flexWrap:"wrap"}}>
        <div style={{flex:1}}>
          <div style={{fontSize:20,fontWeight:800,letterSpacing:"-.03em",lineHeight:1.2}}>Hola, {currentUser?.name.split(" ")[0]} 👋</div>
          <div style={{fontSize:12,color:"var(--text3)",marginTop:3}}>{label}</div>
        </div>
        <div style={{display:"flex",alignItems:"center",gap:8}}>
          <select aria-label="Periodo del resumen" value={dashMes} onChange={e=>setDashMes(e.target.value)}
            style={{padding:"6px 11px",borderRadius:8,border:"1px solid var(--border)",fontSize:12,fontFamily:"var(--font)",background:"var(--surface)",color:"var(--text2)",cursor:"pointer"}}>
            <option value="">Semana actual</option>
            <option value="__year__">Año {currentYear}</option>
            <option value="__total__">Total acumulado</option>
            {allMonths.map(m=><option key={m} value={m}>{new Date(m+"-02").toLocaleString("es-ES",{month:"long",year:"numeric"}).replace(/^\w/,c=>c.toUpperCase())}</option>)}
          </select>
          <button className="btn" onClick={()=>onHomePdf&&onHomePdf({agByTipo,agH,notionItems,label,currentUser,prod})}
            style={{padding:"6px 13px",borderRadius:9,border:"1px solid var(--border)",cursor:"pointer",fontSize:12,background:"var(--surface)",color:"var(--text2)",fontFamily:"var(--font)",display:"flex",alignItems:"center",gap:5}}>
            <Icon name="download" size={12} color="var(--text3)"/>Descargar PDF
          </button>
        </div>
      </div>

      {/* Fichaje a la izquierda (un tercio) y a su derecha, en los dos tercios
          restantes, los KPIs y el cronómetro apilados. Es una rejilla 1fr/2fr y
          no un flex con anchos fijos para que las dos columnas lleguen siempre
          al mismo borde: con 340 px fijos, el fichaje se quedaba corto y el
          resto de tarjetas terminaban en sitios distintos. En tablet/móvil
          .home-top pasa a una sola columna. */}
      <div className="home-top" style={{display:"grid",gridTemplateColumns:fichaje?"minmax(0,1fr) minmax(0,2fr)":"minmax(0,1fr)",gap:14,alignItems:"flex-start",marginBottom:16}}>
        {fichaje&&(
          <div style={{minWidth:0}}>
            <FichajeWidget fichaje={fichaje}/>
          </div>
        )}

        {/* Columna derecha: los KPIs arriba y el cronómetro debajo, rellenando
            el hueco que dejaba el widget de fichaje, que es mucho más alto que
            una fila de tarjetas. minWidth:0 para que el contenido no impida a la
            columna encogerse cuando toca envolver. */}
        <div style={{minWidth:0,display:"flex",flexDirection:"column",gap:14}}>

        {/* Cronómetro de tarea, lo primero de la columna: es lo que se hace
            varias veces al día. Aquí la columna es lo bastante ancha para los
            buscadores de tarea, que despliegan hasta 440 px. */}
        {crono&&fichaje&&(
          <CronometroWidget
            crono={crono} fichaje={fichaje}
            agendaTiposData={agendaTiposData} misPasos={misPasos}
            notionItems={notionItems} verIncidencias={verIncidencias}
            senalElegir={senalElegir}
            onAbrirPanel={onAbrirPanel} onCerrarJornada={onCerrarJornada}/>
        )}


        {/* KPIs */}
        <div className="kpi-grid" style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(140px,1fr))",gap:10,alignContent:"flex-start"}}>
        {[
          ...(prod.index!==null ? [[
            "graph-up-arrow", prodB.color, prod.index+"%", "Productividad",
            fmtRatio(prod.ratio)+" alta:baja",
          ]] : []),
          ["clock",            "#8b5cf6", agH.toFixed(1)+"h",  "Horas Cuaderno",   "en "+label.toLowerCase()],
          ["journal-text",     "var(--accent)", myAgenda.length,     "Entradas",         "en el cuaderno"],
        ].map(([ic,cl,val,lab,sub],i)=>(
          <div key={lab} className={"fu s"+(i+1)} style={{...card,padding:"13px 14px",borderTop:"3px solid "+cl}}>
            <Icon name={ic} size={16} color={cl} style={{marginBottom:5,display:"block"}}/>
            <div style={{fontSize:10,fontWeight:700,textTransform:"uppercase",letterSpacing:".08em",color:"var(--text3)",marginBottom:2}}>{lab}</div>
            <div style={{fontSize:22,fontWeight:800,color:cl,lineHeight:1}}>{val}</div>
            <div style={{fontSize:10,color:"var(--text3)",marginTop:2}}>{sub}</div>
          </div>
        ))}
        </div>

        {/* Lo de Notion, en una sola línea: son cifras de la integración, no
            algo sobre lo que se decida cada día. */}
        {notionItems.length>0&&(
          <div style={{display:"flex",alignItems:"center",gap:6,fontSize:12,color:"var(--text2)",flexWrap:"wrap"}}>
            <Icon name="folder2-open" size={13} color="var(--text3)"/>
            Notion: <b>{notionDbs.length}</b> {notionDbs.length===1?"proyecto":"proyectos"} · <b>{notionPages.length}</b> {notionPages.length===1?"página":"páginas"} sincronizadas
          </div>
        )}

        </div>
      </div>

      {/* Fila: cuaderno + notion */}
      <div className="grid-1col-mob" style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:14,marginBottom:14}}>
        {/* Cuaderno por tipo */}
        <div style={{...card,padding:16}}>
          <div style={{fontWeight:700,fontSize:11,color:"var(--text2)",marginBottom:12,textTransform:"uppercase",letterSpacing:".07em",display:"flex",alignItems:"center",gap:6}}>
            <Icon name="journal-text" size={13} color="var(--accent)"/>Cuaderno · {label}
          </div>
          {/* Reparto por productividad: el % del KPI necesita ver de dónde sale */}
          {prod.index!==null&&(
            <div style={{marginBottom:12}}>
              <div style={{height:8,borderRadius:4,overflow:"hidden",display:"flex",background:"var(--bg)",marginBottom:5}}>
                {[["alta",prod.alta],["media",prod.media],["baja",prod.baja]].map(([k,h])=>{
                  if(!h) return null;
                  const c=prodBand(k==="alta"?100:k==="media"?50:0).color;
                  return <div key={k} title={`Productividad ${k}: ${fmtHours(h)}`}
                    style={{height:"100%",width:Math.round(h/(prod.horas||1)*100)+"%",background:c}}/>;
                })}
              </div>
              <div style={{display:"flex",gap:10,flexWrap:"wrap",fontSize:10,color:"var(--text3)"}}>
                {[["alta",prod.alta],["media",prod.media],["baja",prod.baja]].filter(([,h])=>h>0).map(([k,h])=>{
                  const c=prodBand(k==="alta"?100:k==="media"?50:0).color;
                  return (
                    <span key={k} style={{display:"flex",alignItems:"center",gap:4}}>
                      <span style={{width:6,height:6,borderRadius:2,background:c,display:"inline-block"}}/>
                      {k} <b style={{color:c}}>{fmtHours(h)}</b>
                    </span>
                  );
                })}
                {prod.sinTipo>0&&<span>· {fmtHours(prod.sinTipo)} sin tipo, fuera del índice</span>}
              </div>
            </div>
          )}
          {Object.entries(agByTipo).length===0
            ?<p style={{fontSize:12,color:"var(--text3)",fontStyle:"italic"}}>Sin entradas en este período</p>
            :Object.entries(agByTipo).sort((a,b)=>b[1]-a[1]).map(([tp,h])=>{
              const col=AG_TIPO_CLR[tp]||"#9ca3af";
              const maxH=Math.max(...Object.values(agByTipo));
              return (
                <div key={tp} style={{marginBottom:8}}>
                  <div style={{display:"flex",justifyContent:"space-between",fontSize:11,marginBottom:3}}>
                    <span style={{fontWeight:600,color:"var(--text2)"}}>{tp}</span>
                    <span style={{fontWeight:700,color:col}}>{h.toFixed(1)}h</span>
                  </div>
                  <div style={{height:5,background:"var(--bg)",borderRadius:3,overflow:"hidden"}}>
                    <div style={{height:"100%",width:Math.round(h/maxH*100)+"%",background:col,borderRadius:3,transition:"width .5s"}}/>
                  </div>
                </div>
              );
            })
          }
          <button className="btn" onClick={()=>go("cuaderno")}
            style={{marginTop:10,width:"100%",padding:"7px",border:"1px dashed var(--border)",borderRadius:8,cursor:"pointer",fontSize:11,color:"var(--accent)",background:"var(--accent-bg)",fontFamily:"var(--font)",display:"flex",alignItems:"center",justifyContent:"center",gap:5}}>
            <Icon name="journal-text" size={11} color="var(--accent)"/>Abrir Cuaderno
          </button>
        </div>

        {/* Mis tareas: salida gradual (admin y TIC primero). Sin permiso no se pinta nada. */}
        {verMisTareas&&<MisTareasCard card={card} onVerTodas={()=>go("tareas")}/>}

        {/* Mis proyectos (gestor nativo) primero: Notion es el segundo mundo de proyectos
            y queda debajo, a ancho completo y como secundario. */}
        <MisProyectos currentUser={currentUser} card={card}
          onAbrir={onAbrirProyecto} onVerTodos={()=>go("projects")}/>

        {/* Proyectos Notion */}
        <div style={{...card,padding:16,gridColumn:"1 / -1"}}>
          <div style={{fontWeight:700,fontSize:11,color:"var(--text2)",marginBottom:12,textTransform:"uppercase",letterSpacing:".07em",display:"flex",alignItems:"center",gap:6}}>
            <span style={{width:14,height:14,background:"#000",borderRadius:3,display:"inline-flex",alignItems:"center",justifyContent:"center",fontSize:10,fontWeight:900,color:"#fff",flexShrink:0}}>N</span>
            Notion · Proyectos
          </div>
          {notionDbs.length===0
            ?(
              <div style={{textAlign:"center",padding:"16px 0"}}>
                <p style={{fontSize:12,color:"var(--text3)",fontStyle:"italic",marginBottom:10}}>Sin proyectos sincronizados</p>
                <button className="btn" onClick={()=>setModal("integrations")}
                  style={{padding:"7px 14px",borderRadius:8,border:"1px solid var(--border)",cursor:"pointer",fontSize:12,background:"var(--surface)",color:"var(--accent)",fontFamily:"var(--font)"}}>
                  Conectar Notion
                </button>
              </div>
            )
            :notionDbs.slice(0,6).map(db=>(
              <a key={db.external_id} href={db.url||"#"} target="_blank" rel="noreferrer"
                style={{display:"flex",alignItems:"center",gap:8,padding:"6px 0",borderBottom:"1px solid var(--border2)",textDecoration:"none",color:"inherit"}}>
                <span style={{fontSize:15,flexShrink:0,width:20,textAlign:"center"}}>{db.icon||"📁"}</span>
                <div style={{flex:1,minWidth:0}}>
                  <div style={{fontSize:12,fontWeight:600,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{db.title}</div>
                  {db.status&&<div style={{fontSize:10,color:"var(--text3)"}}>{db.status}</div>}
                </div>
                <Icon name="box-arrow-up-right" size={10} color="var(--text3)"/>
              </a>
            ))
          }
          {notionDbs.length>0&&(
            <button className="btn" onClick={()=>go("projects")}
              style={{marginTop:10,width:"100%",padding:"7px",border:"1px dashed var(--border)",borderRadius:8,cursor:"pointer",fontSize:11,color:"var(--accent)",background:"var(--accent-bg)",fontFamily:"var(--font)",display:"flex",alignItems:"center",justifyContent:"center",gap:5}}>
              <Icon name="folder2-open" size={11} color="var(--accent)"/>Ver todos en Proyectos
            </button>
          )}
        </div>
      </div>

      {/* Cuaderno por equipo donut */}
      {myAgenda.length>0&&(
        <div style={{...card,padding:16,marginBottom:14}}>
          <div style={{fontWeight:700,fontSize:11,color:"var(--text2)",marginBottom:12,textTransform:"uppercase",letterSpacing:".07em",display:"flex",alignItems:"center",gap:6}}>
            <Icon name="people-fill" size={13} color="var(--accent)"/>Horas por equipo · {label}
          </div>
          {(()=>{
            const byDept={};
            myAgenda.forEach(a=>{const d=a.department||"Sin equipo";byDept[d]=(byDept[d]||0)+(a.hours||0);});
            const sorted=Object.entries(byDept).sort((a,b)=>b[1]-a[1]);
            const maxH=sorted[0]?.[1]||1;
            const colors=["#8b5cf6","#0b7d96","#22c55e","#f59e0b","#ef4444","#06b6d4"];
            return (
              <div style={{display:"flex",gap:20,alignItems:"center",flexWrap:"wrap"}}>
                <DonutChart data={sorted.map(([,h],i)=>({value:h,color:colors[i%colors.length]}))} size={80} stroke={14} descripcion="Horas por equipo"/>
                <div style={{flex:1,minWidth:160}}>
                  {sorted.map(([dept,h],i)=>(
                    <div key={dept} style={{marginBottom:6}}>
                      <div style={{display:"flex",justifyContent:"space-between",fontSize:11,marginBottom:2}}>
                        <span style={{fontWeight:600,color:"var(--text2)",display:"flex",alignItems:"center",gap:5}}>
                          <span style={{width:8,height:8,borderRadius:2,background:colors[i%colors.length],flexShrink:0,display:"inline-block"}}/>
                          {dept}
                        </span>
                        <span style={{fontWeight:700,color:colors[i%colors.length]}}>{h.toFixed(1)}h</span>
                      </div>
                      <div style={{height:4,background:"var(--bg)",borderRadius:3,overflow:"hidden"}}>
                        <div style={{height:"100%",width:Math.round(h/maxH*100)+"%",background:colors[i%colors.length],borderRadius:3,transition:"width .5s"}}/>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            );
          })()}
        </div>
      )}

      {/* Entradas recientes */}
      {myAgenda.length>0&&(
        <div style={{...card,padding:16}}>
          <div style={{fontWeight:700,fontSize:11,color:"var(--text2)",marginBottom:10,textTransform:"uppercase",letterSpacing:".07em",display:"flex",alignItems:"center",gap:6}}>
            <Icon name="clock-history" size={13} color="var(--accent)"/>Entradas recientes · {label}
          </div>
          <div style={{display:"flex",flexDirection:"column",gap:4}}>
            {myAgenda.slice(0,6).map(a=>{
              const col=AG_TIPO_CLR[a.type]||"#9ca3af";
              return (
                <div key={a.id} style={{display:"flex",alignItems:"center",gap:10,padding:"6px 8px",borderRadius:8,background:"var(--bg)"}}>
                  <span style={{width:8,height:8,borderRadius:2,background:col,flexShrink:0}}/>
                  <span style={{flex:1,fontSize:12,fontWeight:500,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{a.description||"—"}</span>
                  <span style={{fontSize:10,color:"var(--text3)",whiteSpace:"nowrap"}}>{a.entry_date}</span>
                  <span style={{fontSize:11,fontWeight:700,color:"var(--accent)",whiteSpace:"nowrap"}}>{(a.hours||0).toFixed(1)}h</span>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}
